import type DevtoolsStateType from './DevtoolsStateType';
import { DEVTOOLS_TYPES } from './DevtoolsStateType';
import type { DevtoolsReducerActionType } from './DevtoolsStateType';

import memberReducer, {
  actions as memberActions,
} from './member/devtools.member.reducer';

export default function devtoolsReducer(
  state: DevtoolsStateType,
  action: DevtoolsReducerActionType
): DevtoolsStateType {
  let newState: DevtoolsStateType = {
    ...state,
  };

  switch (action.type) {
    case DEVTOOLS_TYPES.DEVTOGGLE_DEVTOOL:
      newState = {
        ...newState,
        enabled: !!action.payload?.enabled,
      };
      break;
    default:
      break;
  }

  if (memberActions.includes(action.type)) {
    newState = {
      ...memberReducer(newState, action),
    };
  }

  return newState;
}
